import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-checkout-complete',
  templateUrl: './checkout-complete.component.html',
  styleUrls: ['./checkout-complete.component.scss']
})
export class CheckoutCompleteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
